/**
 * 最近読んだ・見た作品を出す Home ウィジェット。
 *
 * タップで前回の話を直接開く。Safe モードで隠すドメインは、復帰ダイアログと同じく
 * ユーザーの Safe モードに関係なく取得時点で除いてある。
 */

import { History } from 'lucide-react'

import type { ProductProgress } from '@/api/types/user'
import type { NavigateFn } from '@/components/home/home-widget-data'
import { ThumbnailGridWidget } from '@/components/home/thumbnail-grid-widget'
import { AuthImage } from '@/components/ui/auth-image'
import type { WidgetSize } from '@/store/useHomeLayoutStore'

const HISTORY_PATH = '/p?order_by=last_read'

/** 話が消えて前回の話が分からないときは、作品の話一覧を開く */
const pathOf = (item: ProductProgress): string =>
  item.last_episode_id !== null
    ? `/p/${item.last_episode_id}`
    : `/p?domain=${item.domain}&openEpisodes=${item.product_id}`

const Thumbnail = ({ item }: { item: ProductProgress }) => (
  <AuthImage
    src={`/api/p/${item.product_id}/thumbnail`}
    alt={item.title}
    className="size-full object-cover"
    cacheKey={`home-history-${item.product_id}`}
  />
)

export const HistoryWidget = ({
  items,
  size,
  onNavigate,
}: {
  items: ProductProgress[]
  size: WidgetSize
  onNavigate: NavigateFn
}) => (
  <ThumbnailGridWidget
    items={items.map((item) => ({
      key: item.product_id,
      title: item.title,
      thumbnail: <Thumbnail item={item} />,
      onOpen: () => onNavigate(pathOf(item)),
    }))}
    size={size}
    icon={History}
    label="履歴"
    accentClassName="text-teal-400"
    emptyMessage="履歴なし"
    onOpenEmpty={() => onNavigate(HISTORY_PATH)}
  />
)
